import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
 
import useBenefitMaxScheduleSteps from "./hooks/useBenefitMaxStepSchedule";
const BenefitMaxScheduleSteps = () => {  
  const benefitMaxScheduleStepsData = useBenefitMaxScheduleSteps();  
  
  return (  
    <div class="container container-fluid"> 
      <ButtonsSection ctaButtons={benefitMaxScheduleStepsData.leftButtons} align="left" /> 
      <div className="header-section">  
        <h1>  
          {benefitMaxScheduleStepsData.screen_title} -{" "}  
          <span className="heading-cod">{benefitMaxScheduleStepsData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={benefitMaxScheduleStepsData.formFields}  
        dropdownValues={benefitMaxScheduleStepsData.dropdownValues}  
        paramsData={benefitMaxScheduleStepsData.paramsData}  
        updataParamData={benefitMaxScheduleStepsData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={benefitMaxScheduleStepsData.ctaButtons} />  
      <DisplayTable  
        data={benefitMaxScheduleStepsData.data}  
        parmKey={benefitMaxScheduleStepsData.parmkey}  
        menuOptions={benefitMaxScheduleStepsData.menuOptions}  
        tableHeaders={benefitMaxScheduleStepsData.columnDef}  
        setRowData={benefitMaxScheduleStepsData.setRowData}  
        selectedPriceSchedules={benefitMaxScheduleStepsData.selectedRows}  
        setSelectedPriceSchedules={benefitMaxScheduleStepsData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={benefitMaxScheduleStepsData.first}  
          rows={benefitMaxScheduleStepsData.rows}  
          totalRecords={benefitMaxScheduleStepsData.totalRecords}  
          currentPage={benefitMaxScheduleStepsData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={benefitMaxScheduleStepsData.onPageChange}  
        />  
      </div>  
      {benefitMaxScheduleStepsData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={benefitMaxScheduleStepsData.isConfirmationModalOpen}  
          onRequestClose={benefitMaxScheduleStepsData.closeConfirmationModal}  
          onBack={benefitMaxScheduleStepsData.closeConfirmationModal}  
          onSave={benefitMaxScheduleStepsData.deleteBenefitMaxScheduleStep}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={benefitMaxScheduleStepsData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default BenefitMaxScheduleSteps; 